// ** Components
import Link from '@/components/common/Link';
import Button from '@/components/common/Button';
import Section from '@/components/common/Section';

// ** Types
import type { StrapiComponentProps } from '@/types/strapi';
import type { ComponentBlocksButtonLink as ButtonLinkProps } from '@/types/graphql';

type ComponentBlocksButtonLinkProps = StrapiComponentProps<ButtonLinkProps>;

const ComponentBlocksButtonLink = ({ url, text, containerSx, buttonVariant }: ComponentBlocksButtonLinkProps) => {
	return (
		<Section
			containerSx={{
				...containerSx
			}}
		>
			<Link href={url} target="_blank" rel="noopener noreferrer">
				<Button
					variant={buttonVariant.toLowerCase() as 'contained' | 'outlined' | 'text'}
					size="large"
					sx={{
						px: 8,
						py: 2.5,
						fontSize: 24,
						fontWeight: 900,
						whiteSpace: 'pre-line'
					}}
				>
					{text}
				</Button>
			</Link>
		</Section>
	);
};

export default ComponentBlocksButtonLink;
